<template>
<div class="chapter">
<div class="inner_page">
<div class="ipadfp"><img alt="Cover: The Many Lives &amp; Secret Sorrows of Josephine B, by Sandra Gulland" class="imagefp" src="images/9780743213578.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?a48d9710